import { render, staticRenderFns } from "./ThemeNewsListItem.vue?vue&type=template&id=0b62d9dc&scoped=true"
import script from "./ThemeNewsListItem.vue?vue&type=script&lang=js"
export * from "./ThemeNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./ThemeNewsListItem.vue?vue&type=style&index=0&id=0b62d9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b62d9dc",
  null
  
)

export default component.exports